"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_redux_1 = require("react-redux");
const editableCampaign_1 = require("../../../../actions/editableCampaign");
const reducers_1 = require("../../../../reducers");
const PopoverModalForm_1 = require("../../components/PopoverModalForm");
const src_1 = require("@rover/ts-bootstrap/dist/src");
const daysOfTheWeek = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
class DaysOfWeekPicker extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            updatedDays: {},
        };
        this.getPopoverFormInputProps = this.getPopoverFormInputProps.bind(this);
        this.getPopoverModalProps = this.getPopoverModalProps.bind(this);
        this.getPopoverNavbarProps = this.getPopoverNavbarProps.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.getAddButton = this.getAddButton.bind(this);
        this.getEditButton = this.getEditButton.bind(this);
    }
    getAddButton() {
        const { device } = this.props;
        switch (device) {
            case 'Desktop':
                return (React.createElement("div", { key: "automated-days-of-the-week-add" },
                    React.createElement(src_1.Button, { text: "Add", type: "regular", style: {
                            innerStyle: {
                                fontSize: 17,
                            },
                            outerStyle: {
                                height: null,
                                lineHeight: '24px',
                            },
                        }, mouseDownColors: {
                            active: src_1.turquoise,
                            inactive: src_1.aquamarine,
                        } })));
            case 'Tablet':
                return React.createElement(src_1.PlusIcon, { key: "automated-days-of-the-week-add", fill: src_1.titanium });
            default:
                return null;
        }
    }
    getEditButton() {
        const { device } = this.props;
        switch (device) {
            case 'Desktop':
                return (React.createElement(src_1.Button, { text: "Edit", type: "regular", style: {
                        innerStyle: {
                            fontSize: 17,
                        },
                    }, mouseDownColors: {
                        active: src_1.turquoise,
                        inactive: src_1.aquamarine,
                    }, key: "automated-days-of-the-week-change" }));
            case 'Tablet':
                return React.createElement(src_1.ChangeIcon, { key: "automated-days-of-the-week-change", fill: src_1.titanium });
            default:
                return null;
        }
    }
    handleDelete() {
        this.props.removeEventTriggerFilter('DayOfTheWeekEventTriggerFilter');
    }
    getPopoverFormInputProps() {
        const { device, displayDayOfWeek } = this.props;
        return {
            id: `automated-days-of-the-week-picker`,
            label: device !== 'Mobile' ? 'What days of the week can it be delivered?' : 'Days of the Week',
            media: device,
            text: displayDayOfWeek,
            fieldStyle: {
                marginTop: 0,
                padding: device === 'Desktop' ? '24px 0 23px' : 0,
                minHeight: 'none',
                width: '100%',
            },
            isEditingText: false,
            textMode: true,
        };
    }
    getPopoverModalProps(handleClosePopoverModal) {
        return {
            overlayClickHandler: () => this.setState({ updatedDays: {} }),
            placement: 'left',
            navBarProperties: Object.assign({ buttonLeft: 'Cancel', id: 'navBarId', style: {
                    containerStyle: {
                        borderRadius: '3px 3px 0px 0px',
                    },
                } }, this.getPopoverNavbarProps(handleClosePopoverModal)),
        };
    }
    getPopoverNavbarProps(handleClosePopoverModal) {
        const { updateEventTriggerFilters, daysOfTheWeekFilter } = this.props;
        const { updatedDays } = this.state;
        const newAutomatedDaysOfTheWeekFilter = Object.assign(Object.assign({ monday: false, tuesday: false, wednesday: false, thursday: false, friday: false, saturday: false, sunday: false }, daysOfTheWeekFilter), updatedDays);
        const shouldUpdate = Object.values(newAutomatedDaysOfTheWeekFilter).includes(true);
        return {
            buttonRight: shouldUpdate ? 'Done' : '',
            buttonRightCallback: () => {
                if (!shouldUpdate) {
                    return;
                }
                if (Object.values(this.state).every((day) => !day)) {
                    updateEventTriggerFilters(Object.assign({ __typename: 'DayOfTheWeekEventTriggerFilter' }, daysOfTheWeekFilter));
                }
                else {
                    updateEventTriggerFilters(Object.assign({ __typename: 'DayOfTheWeekEventTriggerFilter' }, newAutomatedDaysOfTheWeekFilter));
                }
                handleClosePopoverModal();
            },
            buttonLeftCallback: () => {
                this.setState({ updatedDays: {} }, handleClosePopoverModal);
            },
        };
    }
    getIsDayChecked(day) {
        const { daysOfTheWeekFilter = {
            __typename: 'DayOfTheWeekTriggerFilter',
            monday: false,
            tuesday: false,
            wednesday: false,
            thursday: false,
            friday: false,
            saturday: false,
            sunday: false,
        }, } = this.props;
        if (!daysOfTheWeekFilter) {
            return false;
        }
        const { __typename } = daysOfTheWeekFilter, rest = __rest(daysOfTheWeekFilter, ["__typename"]);
        const { updatedDays } = this.state;
        const mergedDays = Object.assign(Object.assign({}, rest), updatedDays);
        return daysOfTheWeek.filter((d) => !!mergedDays[d]).includes(day);
    }
    render() {
        const { device } = this.props;
        const { updatedDays } = this.state;
        return (React.createElement(PopoverModalForm_1.default, { popoverFormInputProps: this.getPopoverFormInputProps(), presentationType: device !== 'Mobile' ? 'popover' : 'modal', field: "automated-days-of-the-week-picker", popoverModalProps: this.getPopoverModalProps, popoverNavbarProps: this.getPopoverNavbarProps, handleSaveChange: this.handleDelete, addButton: this.getAddButton(), editButton: this.getEditButton() },
            React.createElement("div", { style: {
                    overflow: 'scroll',
                    height: device === 'Mobile' ? window.screen.availHeight - 56 : null,
                } },
                React.createElement(src_1.SelectableList, { device: device }, daysOfTheWeek.map((day, index) => (React.createElement("div", { key: index, style: {
                        alignItems: 'center',
                        display: 'flex',
                        height: device === 'Mobile' ? 72 : 56,
                        justifyContent: 'space-between',
                        width: device === 'Mobile' ? '100%' : 352,
                    }, onClick: (e) => {
                        e.stopPropagation();
                        this.setState({
                            updatedDays: Object.assign(Object.assign({}, updatedDays), { [day]: !this.getIsDayChecked(day) }),
                        });
                    } },
                    React.createElement(src_1.Text, { text: day.length > 0 ? day[0].toUpperCase() + day.slice(1) : '', size: device === 'Mobile' ? 'large' : 'medium' }),
                    React.createElement(src_1.CheckBox, { checked: this.getIsDayChecked(day), value: day, onClick: () => null }))))))));
    }
}
const mapStateToProps = (state) => ({
    daysOfTheWeekFilter: reducers_1.getEditableCampaignDayOfTheWeekEventTriggerFilter(state),
    displayDayOfWeek: reducers_1.getEditableCampaignDayOfWeekDisplayName(state),
});
const mapDispatchToProps = (dispatch) => {
    return {
        removeEventTriggerFilter: (filterName) => {
            dispatch(editableCampaign_1.removeEventTriggerFilter(filterName));
        },
        updateEventTriggerFilters: (filter) => {
            dispatch(editableCampaign_1.updateEventTriggerFilters(filter));
        },
    };
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(DaysOfWeekPicker);
